module.exports = __webpack_public_path__ + "static/img/office_03.144773a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/office_03.png
// module id = kBeQ
// module chunks = 0